// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3H5-T","container":"styles_container__2yKaH","loader":"styles_loader__3MrgP"};